import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

function event(): EventData {
  return {
    event_type: EventType.engagement,
    source_page: SourcePages.SrpTile,
    feature: Features.srpTile,
    engagement_type: 'view_more_tap',
  };
}

export default event;
